import React, { useState, useEffect } from "react";
import moment from "moment";
import { useParams } from "react-router";
import { NavLink, useNavigate } from "react-router-dom";

import { db } from "./firebase";
import { collection, getDocs, query, where } from "firebase/firestore";

// images
import Logo from "../images/25.png";
import Gift from "../images/gift.gif";
import Swipe from "../images/swipe2.gif";

import { Animated } from "react-animated-css";

// components
import "antd/dist/antd.css";
import {
  Button,
  Divider,
  Space,
  Row,
  Col,
  Badge,
  Affix,
  message,
  Drawer,
  Spin,
  Checkbox,
} from "antd";

import {
  LeftCircleOutlined,
  ShoppingOutlined,
  TagOutlined,
  ShareAltOutlined,
  LeftOutlined,
  RightOutlined,
} from "@ant-design/icons";
import { compose } from "redux";

const CryptoJS = require("crypto-js");

function Event() {
  const encrypt = (data) => {
    return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(data));
  };

  const decrypt = (data) => {
    return CryptoJS.enc.Base64.parse(data).toString(CryptoJS.enc.Utf8);
  };

  const { id, refcode } = useParams();
  const [loading, setLoading] = useState(false);
  const [loadingSwipe, setLoadingSwipe] = useState(false);
  const [cart, setCart] = useState([]);
  const [allPackages, setAllPackages] = useState([]);
  const [subPackages, setSubPackages] = useState([]);
  const [visible, setVisible] = useState(false);
  const [reoption, setReoption] = useState(false);

  let navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    setLoadingSwipe(true);

    setRefCode();
    checkStatusWeb();
    getCart();
    getPackages();

    setTimeout(() => {
      setLoading(false);
    }, 1000);

    setTimeout(() => {
      setLoadingSwipe(false);
    }, 4000);
  }, []);

  const setRefCode = () => {
    if (refcode !== undefined) {
      localStorage.setItem("RefCode", JSON.stringify(decrypt(refcode)));
    }
  };

  const checkStatusWeb = async () => {
    const querySnapshot = await getDocs(
      query(collection(db, "control_web"), where("isactive", "==", false))
    );

    const res = querySnapshot.docs
      .map((doc) => doc.data())
      .filter(
        (x) =>
          moment().format("YYYY-MM-DD HH:mm:ss") >=
            moment().format(x.start_date, "YYYY-MM-DD HH:mm:ss") &&
          moment().format("YYYY-MM-DD HH:mm:ss") <=
            moment().format(x.end_date, "YYYY-MM-DD HH:mm:ss")
      );

    if (res.length !== 0) {
      navigate("/maintain");
    }
  };

  const getCart = async () => {
    if (
      JSON.parse(localStorage.getItem("Cart")) &&
      JSON.parse(localStorage.getItem("Cart")).length !== 0
    ) {
      const querySnapshot = await getDocs(
        query(collection(db, "packages"), where("isactive", "==", true))
      );
      const allPack = querySnapshot.docs.map((doc) => doc.data());

      const cartPack = JSON.parse(localStorage.getItem("Cart")).filter(
        (x) =>
          moment().format("YYYY-MM-DD HH:mm:ss") >=
            moment().format(x.start_date, "YYYY-MM-DD HH:mm:ss") &&
          moment().format("YYYY-MM-DD HH:mm:ss") <=
            moment().format(x.end_date, "YYYY-MM-DD HH:mm:ss") &&
          x.isactive === true
      );

      let arr = [];
      for (let i = 0; i < allPack.length; i++) {
        for (let j = 0; j < cartPack.length; j++) {
          if (
            allPack[i].ecoupon_code === cartPack[j].ecoupon_code &&
            allPack[i].isactive === cartPack[j].isactive &&
            allPack[i].start_date === cartPack[j].start_date &&
            allPack[i].end_date === cartPack[j].end_date
          ) {
            arr.push(cartPack[j]);
          }
        }
      }

      setCart(arr);
      localStorage.removeItem("Cart");
      localStorage.setItem("Cart", JSON.stringify(arr));
    }
  };

  const getPackages = async () => {
    const querySnapshot = await getDocs(
      query(
        collection(db, "packages"),
        where("isactive", "==", true),
        where("event", "==", id)
      )
    );
    const pcks = querySnapshot.docs.map((doc) => doc.data());

    const event = pcks.filter(
      (x) =>
        // (x.row_id === id || x.promotion === id) &&
        moment().format("YYYY-MM-DD HH:mm:ss") >=
          moment().format(x.start_date, "YYYY-MM-DD HH:mm:ss") &&
        moment().format("YYYY-MM-DD HH:mm:ss") <=
          moment().format(x.end_date, "YYYY-MM-DD HH:mm:ss")
      //  &&
      // x.isactive === true
    );

    // console.log(event);

    if (event.length !== 0) {
      setAllPackages(event);
    } else {
      navigate("/");
    }
  };

  const Loading = () => {
    return (
      <div className="center">
        <img src={Gift} style={{ width: "20%" }} alt="" />
        <br /> <p>Loading...</p>
      </div>
    );
  };

  const onClose = () => {
    setSubPackages([]);
    setVisible(false);
  };

  const onChange = (e) => {
    // single-select behavior: when checked set that option only; when unchecked clear selection
    if (e.checked === true) {
      setSubPackages([e.value]);
    } else {
      setSubPackages([]);
    }
  };

  const addProduct = (product) => {
    let arr = [];
    const idx = moment().format("HHmmss");

    for (let i = 0; i < subPackages.length; i++) {
      subPackages[i]["qty"] = 1;
      subPackages[i]["idx"] = idx;
      arr.push(subPackages[i]);
    }

    product["qty"] = 1;
    product["idx"] = idx;

    arr.push(product);

    let storage_cart = JSON.parse(localStorage.getItem("Cart"));

    if (storage_cart !== null) {
      for (let i = 0; i < storage_cart.length; i++) {
        arr.push(storage_cart[i]);
      }
    }

    if (arr.find((x) => x.type === "event") !== undefined) {
      const handleCart = arr.map((x) =>
        x.type === "normal"
          ? {
              ...x,
              // n_row_id: x.row_id,
              n_price_pro: x.price_pro,
              n_type: x.type,
              n_ecoupon_code: x.ecoupon_code,
              n_promotion: x.promotion,
              // row_id: x.p_row_id,
              price_pro: x.p_price_pro,
              type: x.p_type,
              ecoupon_code: x.p_ecoupon_code,
              promotion: x.p_promotion,
            }
          : x
      );

      localStorage.removeItem("Cart");
      localStorage.setItem("Cart", JSON.stringify(handleCart));
      setCart(handleCart);
    } else {
      setCart(JSON.parse(localStorage.getItem("Cart")));
    }

    message.success("เพิ่มสินค้าแล้ว");

    onClose();
  };

  const showDrawer = () => {
    setReoption(true);
    setTimeout(() => {
      setReoption(false);
    }, 500);

    if (cart != null && cart.length !== 0) {
      const exist = cart.filter((x) => x.ecoupon_code === id);

      if (exist.length !== 0 && exist.length === exist[0].max_coupon) {
        message.error("จำกัดคำสั่งซื้อ");
      } else {
        setVisible(true);
      }
    } else {
      setVisible(true);
    }
  };

  const copyLink = () => {
    const profile = JSON.parse(localStorage.getItem("Profile"));
    const rcode = JSON.parse(localStorage.getItem("RefCode"));
    if (profile && profile.staff_id != null) {
      navigator.clipboard.writeText(
        window.location.href + "/" + encrypt(profile.staff_id)
      );
      message.success("คัดลอกลิงก์สำเร็จ");
    } else {
      if (rcode) {
        navigator.clipboard.writeText(
          window.location.href + "/" + encrypt(rcode)
        );
        message.success("คัดลอกลิงก์สำเร็จ");
      } else {
        navigator.clipboard.writeText(window.location.href);
        message.success("คัดลอกลิงก์สำเร็จ");
      }
    }
  };

  return (
    <div>
      <Affix offsetTop={0}>
        <div
          style={{
            padding: "20px",
            background: "rgba(255,255,255,0.8)",
            lineHeight: "130%",
          }}
        >
          <>
            <Row>
              <Col style={{ textAlign: "left" }}>
                <LeftCircleOutlined
                  style={{
                    fontSize: "20px",
                    marginTop: "10px",
                    marginRight: "20px",
                    color: "#1e366f",
                  }}
                  onClick={() => navigate("/")}
                />
              </Col>
              <Col flex="auto" style={{ textAlign: "left" }}>
                <span
                  style={{
                    color: "white",
                    fontSize: "20px",
                    paddingRight: "10px",
                  }}
                >
                  <NavLink to="/">
                    {" "}
                    <b>
                      <span style={{ color: "#1e366f", fontSize: "16px" }}>
                        {/* <img src={Logo} alt="" width={35} />  */} Bangkok
                        Hospital Hatyai <br />
                        <span style={{ color: "#b21e2a", fontSize: "14px" }}>
                          Shopping World
                        </span>
                      </span>
                    </b>
                  </NavLink>
                </span>
              </Col>
              <Col style={{ textAlign: "right" }}>
                <Badge count={0}>
                  <div
                    style={{
                      background: "white",
                      borderRadius: "25px",
                      cursor: "pointer",
                      marginRight: "5px",
                    }}
                    onClick={() => copyLink()}
                  >
                    <ShareAltOutlined
                      style={{
                        color: "#1e366f",
                        fontSize: "28px",
                        padding: "7px",
                      }}
                    />
                  </div>
                </Badge>
                <NavLink to="/cart">
                  <Badge
                    count={
                      cart != null
                        ? cart.filter((x) => x.type !== "option").length
                        : null
                    }
                  >
                    <div style={{ background: "white", borderRadius: "25px" }}>
                      <ShoppingOutlined
                        style={{
                          color: "#1e366f",
                          fontSize: "28px",
                          padding: "7px",
                        }}
                      />
                    </div>
                  </Badge>
                </NavLink>
              </Col>
            </Row>
          </>
        </div>
        <Divider style={{ margin: "0px" }} />
      </Affix>

      {loading ? (
        <Loading />
      ) : (
        <>
          <Animated animationIn="fadeInUp">
            {allPackages.length !== 0 ? (
              <>
                {allPackages.filter((x) => x.ecoupon_code === id)[0].img !==
                "" ? (
                  <>
                    <div style={{ padding: "20px" }}>
                      <img
                        src={
                          allPackages.filter((x) => x.ecoupon_code === id)[0]
                            .img
                        }
                        style={{
                          width: "100%",
                          borderRadius: "25px",
                          boxShadow: "1px 2px 10px #3B5284",
                        }}
                        alt=""
                      ></img>
                    </div>
                    {/* <br /> */}
                  </>
                ) : (
                  <br />
                )}
                <div style={{ textAlign: "center" }}>
                  <div
                    style={{
                      fontSize: "16px",
                      background: "rgba(255,255,255,0.9)",
                      // color:'white',
                      paddingTop: "10px",
                      paddingBottom: "10px",
                      paddingRight: "20px",
                      paddingLeft: "20px",
                      // width:'150px',
                      // borderRadius:'25px'
                    }}
                  >
                    {allPackages.filter((x) => x.ecoupon_code === id)[0].name}
                  </div>
                  {/* <br /> */}
                  {allPackages.filter((x) => x.type === "option").length !==
                  0 ? (
                    <>
                      <span style={{ fontSize: "22px", color: "black" }}>
                        <b style={{ color: "#b21e2a" }}>
                          ฿{" "}
                          {allPackages != null
                            ? allPackages
                                .filter((x) => x.ecoupon_code == id)[0]
                                .price_pro.toLocaleString("en-US")
                            : null}
                        </b>
                      </span>
                      <br />
                      <span style={{ fontSize: "16px", color: "silver" }}>
                        ราคาปกติ{" "}
                        <span
                          style={{
                            textDecoration: "line-through",
                            textDecorationColor: "red",
                          }}
                        >
                          {allPackages.length !== 0
                            ? allPackages
                                .filter((x) => x.ecoupon_code == id)[0]
                                .price.toLocaleString("en-US")
                            : null}
                        </span>
                      </span>
                      <br />
                      <br />
                      <Button
                        style={{
                          color: "#1e366f",
                          borderColor: "#1e366f",
                          marginBottom: "20px",
                        }}
                        ghost
                        shape="round"
                        type="primary"
                        onClick={() => showDrawer()}
                      >
                        เพิ่มไปยังตะกร้า
                        <ShoppingOutlined />
                      </Button>
                      <br />
                      <br />
                    </>
                  ) : null}
                </div>

                {allPackages.filter(
                  (x) =>
                    x.type === "promotion_normal" ||
                    x.type === "promotion_season"
                ).length !== 0 ? (
                  <>
                    {/* <Divider orientation="left">
                        ส่วนลดพิเศษ โปรแกรมตรวจสุขภาพเพื่อคุณ
                        <br />{" "} */}
                    {/* <span style={{ color: "red", fontSize: "12px" }}>
                      *เมื่อซื้อแพ็คเกจ BHH Giftaway
                    </span> */}
                    {/* </Divider> */}

                    <div
                      style={{
                        width: "100%",
                        overflow: "auto",
                        padding: "10px",
                      }}
                    >
                      <center>
                        <Space direction="horizontal">
                          {allPackages.length !== 0
                            ? allPackages
                                .sort((a, b) => {
                                  if (a.recordtime < b.recordtime) {
                                    return -1;
                                  }
                                })
                                .map((product) =>
                                  product.event === id &&
                                  (product.type === "promotion_normal" ||
                                    product.type === "promotion_season") ? (
                                    <>
                                      <NavLink
                                        to={
                                          allPackages.filter(
                                            (x) => x.type === "option"
                                          ).length !== 0
                                            ? `/event/products/${id}/${product.ecoupon_code}`
                                            : `/products/${product.ecoupon_code}`
                                        }
                                      >
                                        <div
                                          style={{
                                            height: "430px",
                                            width: "250px",
                                            background: "rgba(255,255,255,0.9)",
                                            borderRadius: "25px",
                                            padding: "5px",
                                            position: "relative",
                                          }}
                                        >
                                          <img
                                            src={product.img}
                                            style={{
                                              margin: "6px",
                                              height: "230px",
                                              borderRadius: "25px",
                                              boxShadow: "1px 2px 10px silver",
                                            }}
                                            alt=""
                                          ></img>
                                          {product.price !== 0 ? (
                                            <>
                                              <div
                                                className="circle"
                                                style={{
                                                  position: "absolute",
                                                  top: "0px",
                                                  right: "0px",
                                                }}
                                              >
                                                <p className="content">
                                                  <span
                                                    style={{ fontSize: "20px" }}
                                                  >
                                                    -
                                                    {Math.floor(
                                                      ((product.price -
                                                        product.price_pro) /
                                                        product.price) *
                                                        100
                                                    )}
                                                    %
                                                  </span>
                                                  <br />
                                                  OFF
                                                </p>
                                              </div>
                                            </>
                                          ) : null}
                                          <br />
                                          <br />
                                          <p style={{ color: "black" }}>
                                            {product.name}
                                          </p>
                                          {product.detail !== "" ? (
                                            <>
                                              {" "}
                                              <span
                                                style={{
                                                  fontSize: "14px",
                                                  color: "red",
                                                }}
                                              >
                                                {product.detail}{" "}
                                              </span>
                                              <br />
                                              <br />
                                            </>
                                          ) : null}
                                          <span
                                            style={{
                                              fontSize: "16px",
                                              color: "#b21e2a",
                                            }}
                                          >
                                            <b>
                                              {/* <TagOutlined /> */}฿{" "}
                                              {product.price_pro.toLocaleString(
                                                "en-US"
                                              )}
                                            </b>
                                          </span>
                                          <br />
                                          {product.price !== 0 ? (
                                            <>
                                              <span
                                                style={{
                                                  fontSize: "14px",
                                                  color: "silver",
                                                }}
                                              >
                                                ราคาปกติ{" "}
                                                <span
                                                  style={{
                                                    textDecoration:
                                                      "line-through",
                                                    textDecorationColor: "red",
                                                  }}
                                                >
                                                  {product.price.toLocaleString(
                                                    "en-US"
                                                  )}
                                                </span>
                                              </span>
                                            </>
                                          ) : null}
                                        </div>
                                        <br />
                                      </NavLink>
                                    </>
                                  ) : null
                                )
                            : null}
                        </Space>
                      </center>
                    </div>
                  </>
                ) : null}

                {allPackages.filter((x) => x.type === "special").length !==
                  0 && (
                  <>
                    <Divider orientation="left">
                      โปรโมชั่นราคาพิเศษสำหรับคุณ
                    </Divider>
                    <div style={{ width: "100%", overflow: "auto" }}>
                      <center>
                        <Space direction="horizontal">
                          {allPackages != null
                            ? allPackages
                                .sort((a, b) => {
                                  if (a.recordtime < b.recordtime) {
                                    return -1;
                                  }
                                })
                                .map((product) =>
                                  product.type === "special" ? (
                                    <>
                                      <NavLink
                                        to={`/products/${product.ecoupon_code}`}
                                      >
                                        <div
                                          style={{ height: "450px" }}
                                          // onClick={() =>
                                          //   localStorage.setItem(
                                          //     "Product",
                                          //     JSON.stringify(product)
                                          //   )
                                          // }
                                        >
                                          <img
                                            src={product.img}
                                            style={{
                                              margin: "6px",
                                              height: "230px",
                                              borderRadius: "25px",
                                              boxShadow: "1px 2px 10px silver",
                                            }}
                                          ></img>
                                          <br />
                                          <br />
                                          <p style={{ color: "#6D583A" }}>
                                            {product.name}
                                          </p>
                                          {product.detail !== "" ? (
                                            <>
                                              {" "}
                                              <span
                                                style={{
                                                  fontSize: "14px",
                                                  color: "red",
                                                }}
                                              >
                                                {product.detail}{" "}
                                              </span>
                                              <br />
                                              <br />
                                            </>
                                          ) : null}
                                          <span
                                            style={{
                                              fontSize: "16px",
                                              color: "black",
                                            }}
                                          >
                                            <b>
                                              {/* <TagOutlined />  */}฿{" "}
                                              {product.price_pro.toLocaleString(
                                                "en-US"
                                              )}
                                            </b>
                                          </span>
                                          <br />
                                          <span
                                            style={{
                                              fontSize: "14px",
                                              color: "silver",
                                            }}
                                          >
                                            ราคาปกติ{" "}
                                            <span
                                              style={{
                                                textDecoration: "line-through",
                                                textDecorationColor: "red",
                                              }}
                                            >
                                              {product.price.toLocaleString(
                                                "en-US"
                                              )}
                                            </span>
                                          </span>
                                        </div>
                                      </NavLink>
                                    </>
                                  ) : null
                                )
                            : null}
                        </Space>
                      </center>
                    </div>
                  </>
                )}
              </>
            ) : null}
          </Animated>

          <Drawer
            title={
              allPackages.length !== 0
                ? allPackages[
                    allPackages.findIndex((x) => x.ecoupon_code == id)
                  ].name
                : null
            }
            placement="bottom"
            onClose={onClose}
            visible={visible}
            height={500}
            extra={
              <Space>
                <Button
                  size="small"
                  onClick={onClose}
                  style={{ borderRadius: "25px" }}
                >
                  ยกเลิก
                </Button>
                <Button
                  size="small"
                  type="primary"
                  disabled={subPackages.length === 0}
                  title={subPackages.length === 0 ? "กรุณาเลือกอย่างน้อย 1 รายการก่อนยืนยัน" : ""}
                  onClick={() =>
                    addProduct(
                      allPackages[
                        allPackages.findIndex((x) => x.ecoupon_code == id)
                      ]
                    )
                  }
                  style={{
                    borderRadius: "25px",
                    background: subPackages.length === 0 ? "#9bb0c7" : "#1e366f",
                    border: 0,
                    cursor: subPackages.length === 0 ? "not-allowed" : "pointer",
                  }}
                >
                  ยืนยัน
                </Button>
              </Space>
            }
          >
            <Divider orientation="center">
              เลือกรับฟรี 1 รายการ
            </Divider>

            <div
              style={{
                textAlign: "center",
                padding: "10px",
              }}
            >
              <Row>
                {/* <Col span={2}></Col>
                <Col span={22}>โปรแกรมตรวจ</Col> */}
                {/* <Col span={5}>ราคาปกติ</Col> */}
                {/* <Col span={5}>ราคาพิเศษ</Col> */}
              </Row>
            </div>

            {reoption ? (
              <Spin spinning={reoption} className="center"></Spin>
            ) : (
              <>
                {allPackages != null
                  ? allPackages.map((product) =>
                      product.type === "option" && product.isactive === true ? (
                        <div
                          style={{
                            textAlign: "center",
                            padding: "10px",
                            marginBottom: "5px",
                            boxShadow: "1px 2px 5px silver",
                          }}
                        >
                          <Row>
                            <Col span={2}>
                              <Checkbox
                                value={product}
                                onChange={(e) => onChange(e.target)}
                                checked={
                                  subPackages.find(
                                    (x) => x.ecoupon_code === product.ecoupon_code
                                  )
                                    ? true
                                    : false
                                }
                              />
                            </Col>
                            <Col
                              span={22}
                              style={{ textAlign: "left", paddingLeft: "10px" }}
                            >
                              {product.name}
                              <br />
                              {product.detail != "-" ? (
                                <span
                                  style={{ color: "red", fontSize: "12px" }}
                                >
                                  {product.detail}
                                </span>
                              ) : null}
                            </Col>
                            {/* <Col
                              span={5}
                              style={{
                                textDecoration: "line-through",
                                textDecorationColor: "red",
                              }}
                            >
                              <span style={{ color: "silver" }}>
                                {product.price.toLocaleString("en-US")}
                              </span>
                            </Col>
                            <Col span={5} style={{ color: "#b21e2a" }}>
                              <b>{product.price_pro.toLocaleString("en-US")}</b>
                            </Col> */}
                          </Row>
                        </div>
                      ) : null
                    )
                  : null}
              </>
            )}
          </Drawer>

          {/* <Affix offsetBottom={0}>
            <div
              style={{
                padding: "15px",
                backgroundColor: "white",
                boxShadow: "0px 0px 10px #000000",
              }}
            >
              <NavLink to="/cart">
                <Button
                  style={{ width: "100%", background: "#1e366f", border: 0 }}
                  type="primary"
                  size="large"
                  on
                >
                  <Row>
                    <Col span={12} style={{ textAlign: "left" }}>
                      <ShoppingOutlined /> ตะกร้าของฉัน
                    </Col>
                    <Col span={12} style={{ textAlign: "right" }}>
                      ฿{" "}
                      {cart != null
                        ? cart
                            .reduce((accumulator, object) => {
                              return (
                                accumulator + object.price_pro * object.qty
                              );
                            }, 0)
                            .toLocaleString("en-US")
                        : 0}
                    </Col>
                  </Row>
                </Button>
              </NavLink>
            </div>
          </Affix> */}
        </>
      )}
    </div>
  );
}

export default Event;
